import React from 'react';
import PropTypes from 'prop-types';

import BasicLabel from 'components/BasicLabel';
import BasicButton from 'components/BasicButton';
import FilesFieldList from 'components/FilesFieldList';

const SendMessageFormAttachmentsFieldList = props => {
  const {
    form,
    name,
    labelText = 'Attachments',
    btnText = 'Add file',
    disabled = false,
    style = { width: '150px', marginBottom: '15px' },
    labelStyles = { fontWeight: 'bold', fontSize: '0.9286rem' },
  } = props;

  const sizeVarName = `${name}Size`;

  const handleAdd = files => {
    const size =
      files.reduce((sum, a) => sum + Number(a.file.size), 0) +
      Number(form.values[sizeVarName]);
    form.setFieldValue(sizeVarName, size, false);
  };

  const handleRemove = (index, attachId, remove) => {
    const size =
      Number(form.values[sizeVarName]) -
      Number(form.values[name][index].file.size);
    form.setFieldValue(sizeVarName, size, false);
    remove(index);
  };

  return (
    <FilesFieldList
      name={name}
      disabled={disabled}
      header={({ inputRef, disabled }) => (
        <>
          <BasicLabel name={name} text={labelText} styles={labelStyles} />
          <div style={style}>
            <BasicButton
              disabled={disabled}
              controlFunc={() => inputRef.current.click()}
              btnWidth={130}
              btnHeight={35}
              btnFontWeight={500}
              btnArrow={false}
              btnTextColor="#27282d"
              btnText={btnText}
            />
          </div>
        </>
      )}
      files={form.values[name]}
      onAdd={files => handleAdd(files)}
      onRemove={(index, id, remove) => handleRemove(index, id, remove)}
    />
  );
};

SendMessageFormAttachmentsFieldList.propTypes = {
  name: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  labelText: PropTypes.string,
  disabled: PropTypes.bool,
  labelStyles: PropTypes.object,
};

export default SendMessageFormAttachmentsFieldList;
